<template>
  <narrow-container>
    <h1 class="headline-secondary text--center">
      {{ $i18n.t('AUTO_TOPUP.LANDING_PAGES.HEADER') }}
    </h1>
    <br>
    <p class="text--center">
      {{ $i18n.t('AUTO_TOPUP.LANDING_PAGES.INFO_TEXT.ACTIVATION.ERROR') }}
    </p>
    <br>
    <div class="block--centered">
      <router-link
        class="button button--blue button--centered"
        :to="{name:'topUp'}"
      >
        {{ $i18n.t('COMMON.OK') }}
      </router-link>
    </div>
  </narrow-container>
</template>

<script>
    export default {
      name: "AutoTopupActivationMPayLandingSuccess",
      components: {},
      mounted: function () {
        this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'AutoTopup',label: 'Error mPay', value: 0, noninteraction: false });
        this.$store.commit("clearLastTopupValue");
      }
    }
</script>

<style scoped lang="scss">
  .button--centered {
    padding-right: 62px;
    padding-left: 62px;
  }
  .block--centered {
    text-align: center;
  }
</style>
